export const listItemSx = {
    marginBottom: '14px',
};

export const listItemButtonSx = {
    padding: '8px 18px',
    borderRadius: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    color: '#111827',

    '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: '#154683',
        color: '#fff',
    },
};
